jQuery(document).ready(function() {
  var bgArray = ['https://cdn.shopify.com/s/files/1/0570/9499/6149/files/11.jpg?v=1628681109' ];
  var bg = bgArray[Math.floor(Math.random() * bgArray.length)];
  $('body.randomImage').css('background-image', 'url('+ bg +')');
});

function setDefaultQtyInputs() {
  document.querySelectorAll('.incubate-collections-add-to-cart-quantity-selector-input').forEach(input => {
    if (!input.value || input.value === '') {
      input.value = '1';
    }
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', setDefaultQtyInputs);

// Run again after a delay to catch injected elements
setTimeout(setDefaultQtyInputs, 1000);
